import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';

export const SCROLL_STORY_STYLE_SCHEMA = {
  visualSide: { default: 'right' },
  visualWidth: { default: 45 },
  mediaAspectRatio: { default: '16/9' },
  gap: { default: '2rem' },
  transition: { default: 'fade' },
  accent: { default: '' },
  border: { default: () => ({ ...BORDERLESS_BORDER }) },
  shadow: { default: 'none' },
  textStyles: { default: {} },
};
